import { getFunctions, httpsCallable } from "firebase/functions";
import { getApp } from "firebase/app";
import config from "./../../config.json";


export function adminMotorbikeInbox() {
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const motorbike = httpsCallable(functions, config.adminMotorbikeInbox);
  return motorbike();
}